const _sym = (key) => Symbol.for(key);
export const Symbols = {
    // #region 通用服务
    Vue: _sym('Vue'),
    I18n: _sym('I18n'),
    Router: _sym('Router'),
    HttpClient: _sym('HttpClient'),
    PsAxios: _sym('PsAxios'),
    ErrorHandlerService: _sym('ErrorHandlerService'),
    DialogService: _sym('DialogService'),
    CopyService: _sym('CopyService'),
    NavgationService: _sym('NavgationService'),
    VeeValidateExtendService: _sym('VeeValidateExtendService'),
    SystemService: _sym('SystemService'),
    Environment: _sym('Environment'),
    UniSetting: _sym('UniSetting'),
    CommonOptionsService: _sym('CommonOptionsService'),
    CreditsService: _sym('CreditsService'),
    // #endregion
    // #region 通用Http服务
    BoHttp: _sym('BoHttp'),
    WorkspaceHttp: _sym('WorkspaceHttp'),
    LabHttp: _sym('LabHttp'),
    CoreBasicHttp: _sym('CoreBasicHttp'),
    AuthService: _sym('AuthService'),
    OpenApiHttp: _sym('OpenApiHttp'),
    DashboardHttp: _sym('DashboardHttp'),
    ToolHttp: _sym('ToolHttp'),
    // #endregion
    // #region Api
    // backoffice
    AccountApiUrls: _sym('AccountApiUrls'),
    AccountApi: _sym('AccountApi'),
    DataResourceApiUrls: _sym('DataResourceApiUrls'),
    DataResourceApi: _sym('DataResourceApi'),
    CompanyReportApiUrls: _sym('CompanyReportApiUrls'),
    CompanyReportApi: _sym('CompanyReportApi'),
    ExportApiUrls: _sym('ExportApiUrls'),
    ExportApi: _sym('ExportApi'),
    CompanyApiUrls: _sym('CompanyApiUrls'),
    CompanyApi: _sym('CompanyApi'),
    CompanyXiaoshouyiApiUrls: _sym('CompanyXiaoshouyiApiUrls'),
    CompanyXiaoshouyiApi: _sym('CompanyXiaoshouyiApi'),
    CompanyDataAnalysisApi: _sym('CompanyDataAnalysisApi'),
    CompanyDataAnalysisUrls: _sym('CompanyDataAnalysisUrls'),
    CompanyConnectApi: _sym('CompanyConnectApi'),
    CompanyConnectUrls: _sym('CompanyConnectUrls'),
    AccountDataAnalysisApi: _sym('AccountDataAnalysisApi'),
    AccountDataAnalysisUrls: _sym('AccountDataAnalysisUrls'),
    AccountDataAnalysisService: _sym('AccountDataAnalysisService'),
    AccountEurekaDataAnalysisService: _sym('AccountEurekaDataAnalysisService'),
    MiscApiUrls: _sym('MiscApiUrls'),
    MiscApi: _sym('MiscApi'),
    PackageApiUrls: _sym('PackageApiUrls'),
    PackageApi: _sym('PackageApi'),
    /** 公司积分充值等（Backoffice company-credits） */
    CreditsApi: _sym('CreditsApi'),
    ProductApiUrls: _sym('ProductApiUrls'),
    ProductApi: _sym('ProductApi'),
    HistoryApiUrls: _sym('HistoryApiUrls'),
    HistoryApi: _sym('HistoryApi'),
    HistoryListService: _sym('HistoryListService'),
    CompanyOrderApiUrls: _sym('CompanyOrderApiUrls'),
    CompanyOrderApi: _sym('CompanyOrderApi'),
    CompanyOrderService: _sym('CompanyOrderService'),
    // system
    SystematicApi: _sym('SystematicApi'),
    SystematicService: _sym('SystematicService'),
    SystemUrls: _sym('SystemUrls'),
    // passport
    PassportSamlUrls: _sym('PassportSamlUrls'),
    PassportOauthUrls: _sym('PassportOauthUrls'),
    PassportPublicUrls: _sym('PassportPublicUrls'),
    InstitutionApi: _sym('InstitutionApi'),
    // marketplace
    MarketplaceApiUrls: _sym('MarketplaceApiUrls'),
    MarketplaceApi: _sym('MarketplaceApi'),
    AuditService: _sym('AuditService'),
    AgencyService: _sym('AgencyService'),
    OperationService: _sym('OperationService'),
    // analytics
    AnalyticsBlackQueryUrls: _sym('AnalyticsBlackQueryUrls'),
    AnalyticsCoreSearhUrls: _sym('AnalyticsCoreSearhUrls'),
    AnalyticsPromptUrls: _sym('AnalyticsPromptUrls'),
    AnalyticsEmailTemplateUrls: _sym('AnalyticsEmailTemplateUrls'),
    // openapi
    OpenApiUrls: _sym('OpenApiUrls'),
    OpenApi: _sym('OpenApi'),
    OpenApiCategoryService: _sym('OpenApiCategoryService'),
    OpenApiWhitelistService: _sym('OpenApiWhitelistService'),
    OpenApiApiService: _sym('OpenApiApiService'),
    OpenApiPackageService: _sym('OpenApiPackageService'),
    OpenApiApiAnalysisService: _sym('OpenApiApiAnalysisService'),
    OpenApiTenantService: _sym('OpenApiTenantService'),
    // workspace
    WorkspaceApiUrls: _sym('WorkspaceApiUrls'),
    WorkspaceApi: _sym('WorkspaceApi'),
    TaskCentersService: _sym('TaskCentersService'),
    TaskAnalysisService: _sym('TaskAnalysisService'),
    DataMigrationService: _sym('DataMigrationService'),
    DataAnalysisService: _sym('DataAnalysisService'),
    DataSeparateService: _sym('DataSeparateService'),
    // resource
    CompanyPermissionApiUrls: _sym('CompanyPermissionApiUrls'),
    CompanyPermissionApi: _sym('CompanyPermissionApi'),
    CompanyPermissionService: _sym('CompanyPermissionService'),
    // CapacityDetail
    CapacityDetailApiUrls: _sym('CapacityDetailApiUrls'),
    CapacityDetailApi: _sym('CapacityDetailApi'),
    CapacityDetailService: _sym('CapacityDetailService'),
    // LAB
    LabApiUrls: _sym('LabApiUrls'),
    LabApi: _sym('LabApi'),
    LabService: _sym('LabService'),
    // homepage
    HomepageApi: _sym('HomepageApi'),
    HomepageApiUrls: _sym('HomepageApiUrls'),
    // #endregion
    // dashboard
    DashboardApi: _sym('DashboardApi'),
    DashboardService: _sym('DashboardService'),
    // #region Service
    BoHelperService: _sym('BoHelperService'),
    CommonService: _sym('CommonService'),
    AccountService: _sym('AccountService'),
    AccountDefaultService: _sym('AccountDefaultService'),
    AccountAddTrialService: _sym('AccountAddTrialService'),
    AccountInfoService: _sym('AccountInfoService'),
    ServiceAccountQueries: _sym('ServiceAccountQueries'),
    PackagesService: _sym('PackagesService'),
    ProductsService: _sym('ProductsService'),
    AccountEditService: _sym('AccountEditService'),
    PrivilegeDataService: _sym('PrivilegeDataService'),
    ExportService: _sym('ExportService'),
    CompanySettingService: _sym('CompanySettingService'),
    CompanyReportService: _sym('CompanyReportService'),
    HomepageService: _sym('HomepageService'),
    AccountBulkAssignEditService: _sym('AccountBulkAssignEditService'),
    PermissionService: _sym('PermissionService'),
    ProductService: _sym('ProductService'),
    // #endregion
    // #region  Company Service
    CompanyService: _sym('CompanyService'),
    CompanyInfoService: _sym('CompanyInfoService'),
    CompanyAddItemService: _sym('CompanyAddItemService'),
    CompanyQueriesService: _sym('CompanyQueriesService'),
    CompanyOpenAPIService: _sym('CompanyOpenAPIService'),
    CompanyDataAnalysisService: _sym('CompanyDataAnalysisService'),
    CompanyUserDataAnalysisService: _sym('CompanyUserDataAnalysisService'),
    CompanyAnalyticsDataAnalysisService: _sym('CompanyAnalyticsDataAnalysisService'),
    CompanyCopilotDataAnalysisService: _sym('CompanyCopilotDataAnalysisService'),
    CompanyEurekaDataAnalysisService: _sym('CompanyEurekaDataAnalysisService'),
    CompanyEurekaAIRDataAnalysisService: _sym('CompanyEurekaAIRDataAnalysisService'),
    CompanyWorkspaceDataAnalysisService: _sym('CompanyWorkspaceDataAnalysisService'),
    CompanyInsightsService: _sym('CompanyInsightsService'),
    CompanyBioDataAnalysisService: _sym('CompanyBioDataAnalysisService'),
    CompanySynapseDataAnalysisService: _sym('CompanySynapseDataAnalysisService'),
    CompanyChemicalDataAnalysisService: _sym('CompanyChemicalDataAnalysisService'),
    CompanyConnectDataAnalysisService: _sym('CompanyConnectDataAnalysisService'),
    SamlCertificateService: Symbol.for('SamlCertificateService'),
    // #endregin
    // #region Company  organization product
    CompanyProductListService: _sym('CompanyProductListService'),
    CompanyPrivilegeListService: _sym('CompanyPrivilegeListService'),
    CompanyOrganizationCommonService: _sym('CompanyOrganizationCommonService'),
    CompanyOrganizationService: _sym('CompanyOrganizationService'),
    CompanyEditPrivilegeService: _sym('CompanyEditPrivilegeService'),
    // #endregion
    // Core Utility
    CoreUtilityApi: _sym('CoreUtilityApi'),
    CoreUtilityService: _sym('CoreUtilityService'),
    // #endregion
    // #region system smal
    SystemSamlApi: _sym('SystemSamlApi'),
    SystemSamlService: _sym('SystemSamlService'),
    SystemSamlApiUrls: _sym('SystemSamlApiUrls'),
    // #endregion
    // #region
    SearchEngineManagementApi: _sym('SearchEngineManagementApi'),
    SearchEngineManagementApiUrls: _sym('SearchEngineManagementApiUrls'),
    SearchEngineManagementService: _sym('SearchEngineManagementService'),
    // #endregion
    // #region
    KickoutApi: _sym('KickoutApi'),
    KickoutApiUrls: _sym('KickoutApiUrls'),
    KickoutService: _sym('KickoutService'),
    // #endregion
    // #region troubleShooting MessageSend
    MessageSendApi: _sym('MessageSendApi'),
    MessageSendService: _sym('MessageSendService'),
    MessageSendApiUrls: _sym('MessageSendApiUrls'),
    // #endregion
    // #region 通知中心
    NoticeCenterApi: _sym('NoticeCenterApi'),
    NoticeCenterUrls: _sym('NoticeCenterUrls'),
    NoticeConfigurationService: _sym('NoticeConfigurationService'),
    // #endregion
    // #region troubleShooting Mail
    MailApi: _sym('MailApi'),
    MailService: _sym('MailService'),
    MailApiUrls: _sym('MailApiUrls'),
    // #endregion
    // #region cache management
    CacheManagementApi: _sym('CacheManagementApi'),
    CacheManagementService: _sym('CacheManagementService'),
    CacheManagementUrls: _sym('CacheManagementUrls'),
    ApplyTrialApi: _sym('ApplyTrialApi'),
    ApplyTrialUrls: _sym('ApplyTrialUrls'),
    ApplyTrialService: _sym('ApplyTrialService'),
    // #region Data Protection
    DataProtectionApi: _sym('DataProtectionApi'),
    DataProtectionService: _sym('DataProtectionService'),
    // #endregion
    // #region Data Analysis
    DataAnalysisApi: _sym('DataAnalysis'),
    DataAnalyseService: _sym('DataAnalyseService'),
    // #endregion
    // #region Behavior
    BehaviorUrls: _sym('BehaviorUrls'),
    BehaviorApi: _sym('BehaviorApi'),
    BehaviorService: _sym('BehaviorService'),
    // #endregion
    // #region  用户角色管理
    IAdminUrls: _sym('IAdminUrls'),
    AdminService: _sym('AdminService'),
    AdminApi: _sym('AdminApi'),
    // #region ReleasePlain
    ReleasePlanUrls: _sym('ReleasePlanUrls'),
    ReleasePlanApi: _sym('ReleasePlanApi'),
    PostmanApi: _sym('PostmanApi'),
    PostmanService: _sym('PostmanService'),
    PostmanUrls: _sym('PostmanUrls'),
    // #region
    CmsUrls: _sym('CmsUrls'),
    CmsApi: _sym('CmsApi'),
    CmsService: _sym('CmsService'),
    // #endregion
    // #region 会话管理
    SessionManagementUrls: _sym('SessionManagementUrls'),
    SessionManagementApi: _sym('SessionManagementApi'),
    SessionManagementService: _sym('SessionManagementService'),
    // #region Tool
    ToolUrls: _sym('ToolUrls'),
    ToolApi: _sym('ToolApi'),
    // #endregion
    /**
     * 自注册链接服务
     */
    SelfRegisterLinkService: _sym('SelfRegisterLinkService'),
    // #region 违规管理
    Service: _sym('IllegalManagementService'),
    IllegalManagementApi: _sym('IllegalManagementApi'),
    IllegalManagementUrls: _sym('IllegalManagementUrls'),
    IllegalManagementService: _sym('IllegalManagementService'),
    // #endregion
    // #region 运营中心
    OperationCenterUrls: _sym('OperationCenterUrls'),
    OperationCenterApi: _sym('OperationCenterApi'),
    // 产品资源位管理
    ProductResourceSpaceService: _sym('ProductResourceSpaceService'),
    ProductResourceSpaceContentDetailService: _sym('ProductResourceSpaceContentDetailService'),
    // #endregion
    // GlobalView
    GlobalViewApi: _sym('GlobalViewApi'),
    GlobalViewUrls: _sym('GlobalViewUrls'),
    GlobalViewService: _sym('GlobalViewService'),
    // CustomerService
    CustomerService: _sym('customerService'),
    // PromptManagement
    PromptManagementApi: _sym('PromptManagementApi'),
    PromptManagementUrls: _sym('PromptManagementUrls'),
    PromptManagementService: _sym('PromptManagementService'),
    // PqlRuleManagementService
    PqlRuleManagementService: _sym('PqlRuleManagementService'),
    PqlRuleManagementApi: _sym('PqlRuleManagementApi'),
    PqlRuleManagementUrls: _sym('PqlRuleManagementUrls'),
    // productLine 产品线
    ProductLineService: _sym('ProductLineService'),
    // EmailTemplateManagement
    EmailTemplateManagementApi: _sym('EmailTemplateManagementApi'),
    EmailTemplateManagementUrls: _sym('EmailTemplateManagementUrls'),
    EmailTemplateManagementService: _sym('EmailTemplateManagementService'),
    Image2CodeService: _sym('Image2CodeService'),
};
